import { useSOP } from '@hakimo-ui/hakimo/data-access';
import { SOPManager } from '@hakimo-ui/hakimo/feature-shared';
import { QueryResult } from '@hakimo-ui/hakimo/ui-elements';

export interface Props {
  locationId: string;
  tenantId: string;
  alarmTypeId?: string;
}

export function AlarmDetailsSOP(props: Props) {
  const { locationId, alarmTypeId, tenantId } = props;

  const queryResult = useSOP({
    locationId,
    alarmTypeId,
  });

  return (
    <div className="dark:bg-ondark-bg-1 bg-onlight-bg-1 rounded-lg px-1">
      <h2 className="flex h-10 items-center px-4 pt-4 font-bold">
        Standard Operating Procedure
      </h2>
      <QueryResult queryResult={queryResult} loadingText="Loading SOP...">
        {({ sop_workflow: sopWorkflow, id }) => (
          <SOPManager
            showTitle={false}
            sopId={id ?? ''}
            sopWorkflow={sopWorkflow}
            locationId={locationId}
            tenantId={tenantId}
            alarmTypeId={alarmTypeId}
            fullWidth={true}
          />
        )}
      </QueryResult>
    </div>
  );
}

export default AlarmDetailsSOP;
